import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Horse_show } from '../../models/horse_show';
import { Store_payment_object } from '../../models/accounting/store/store_payment_object';
import { Store_payment_response } from '../../models/accounting/store/store_payment_response';
import { Store_category } from '../../models/accounting/store/store_category';
import { Store_order_item } from '../../models/accounting/store/store_order_item';
import { Store_item } from '../../models/accounting/store/store_item';
import { Additional_field, Additional_field_response } from '../../models/additional_field';
import { Braintree_customer } from '../../models/accounting/banking/braintree_customer';
import { Braintree_credit_card } from '../../models/accounting/banking/braintree_credit_card';
import { PublicRecordsService } from '../../providers/public-records.service';
import { StoreService } from '../../providers/store.service';
import { PaymentService } from '../../providers/payment.service';
import { BraintreeService } from '../../providers/braintree.service';
import { faCreditCardFront } from '@fortawesome/pro-regular-svg-icons';
import * as uuid from 'uuid';

import { SmsAbstractAppPage } from '../sms-abstract-app-page';

@Component({
  standalone: false,
  selector: 'app-storefront',
  templateUrl: './storefront.component.html',
styleUrls:  ['./storefront.component.css']
})
export class StorefrontComponent extends SmsAbstractAppPage implements OnInit {
	horse_show: Horse_show = new Horse_show({});
	category: Store_category = new Store_category({store_category_items:[]});
	items: Store_order_item[] = [];
	store_payment_object: Store_payment_object = new Store_payment_object();
  faCreditCardFront = faCreditCardFront;
  order_uuid: string = uuid.v4();


  submitted: boolean = false;

  device_data: string = "";

  additional_fields: Additional_field[] = [];
  additional_field_response_map: Map<string, Additional_field_response> = new Map<string, Additional_field_response>();


  constructor(private route: ActivatedRoute,
    private publicRecordsService: PublicRecordsService,
    private storeService: StoreService,
    private paymentService: PaymentService,
    private braintreeService: BraintreeService,
    private router: Router) {
  	super();
  }

  ngOnInit() {

    this.route.params.subscribe(params => {

          if(params['horse_show_id'] && params['category_number']){

              this.publicRecordsService.getHorseShow(params['horse_show_id']).then(horse_show => {

                 this.horse_show = horse_show;

                 this.storeService.getCategory(params['horse_show_id'], params['category_number']).then(category => {

                   this.category = category;

                   //Populate order grid
                   category.store_category_items.forEach((item: Store_item) => {
                     this.items.push(new Store_order_item({
                      order_id: this.order_uuid,
                      quantity: 0,
                      price: item.price,
                      amount: 0,
                      order_date: null,
                      item_id: item.id,
                      item_code: item.code,
                      item_name: item.name,
                      quantity_based: item.quantity_based,
                      amount_based: item.amount_based}));
                   });

                   //Populate additional fields
                  this.category.additional_fields.forEach((field, i) => {
                    this.additional_field_response_map.set(field.name, new Additional_field_response({name: field.name, value: ''}));

                      this.additional_fields.push(field);

                  });

                 }).catch(error => {
                   this.handleError(error);
                 });


              }).catch(error => {
                this.handleError(error);
              });

          } else {
            this.handleError("Horse show ID or category number missing from request");
          }
      });


    this.braintreeService.getDeviceData().then(dd => {
        this.device_data = dd;
    }).catch(error => {
      this.handleError(error);
    });



  }

  onSubmit(): void {
          if(this.store_payment_object.credit_card.cardholder_name == ''){
      this.handleError("Cardholder name must have a value!");
      return;
    }
    if(this.store_payment_object.credit_card.card_number == ''){
      this.handleError("Card number must have a value!");
      return;
    }
    if(this.store_payment_object.credit_card.cvv == ''){
      this.handleError("CVV must have a value!");
      return;
    }
    if(this.store_payment_object.credit_card.month == ''){
      this.handleError("Month must have a value!");
      return;
    }

    if(this.store_payment_object.credit_card.year == ''){
      this.handleError("Year must have a value!");
      return;
    }

    if(this.store_payment_object.credit_card.zip == ''){
      this.handleError("Zip code must have a value!");
      return;
    }
    if(this.store_payment_object.email_address_for_receipt == ''){
      this.handleError("Email must have a value!");
      return;
    }

    this.submitted = true;

    this.store_payment_object.order_id = this.order_uuid;

    let order_total: number = 0;

    let order_item_list: Store_order_item[] = [];

    this.items.forEach((item, i) => {
      if(item.quantity_based){

        if(item.quantity != 0){
          order_total += (item.price * item.quantity);
          order_item_list.push(item);
        }

      } else {

        if(item.amount != 0){
          order_total += item.amount;
         order_item_list.push(item);
        }

      }

    });

    this.store_payment_object.store_item_list = order_item_list;

    //Handle Additional fields
      let field_responses: Additional_field_response[] = [];
      this.additional_field_response_map.forEach((field, key) => {
        if(field.value != ''){
          field_responses.push(field);
        }
      });

    this.store_payment_object.horse_show_id = this.horse_show.id;

    this.store_payment_object.category_number = this.category.number;

    this.store_payment_object.additional_field_values = field_responses;

    this.store_payment_object.order_total = order_total;

    this.braintreeService.getPaymentMethodNonce(this.device_data,
     this.store_payment_object.credit_card.cardholder_name,
     this.store_payment_object.credit_card.card_number,
     this.store_payment_object.credit_card.cvv,
     this.store_payment_object.credit_card.month,
     this.store_payment_object.credit_card.year,
     this.store_payment_object.credit_card.zip,
     this.store_payment_object.credit_card.country).then(bt => {


       this.paymentService.submitStorePayment(this.store_payment_object, bt.nonce, this.device_data).then(store_payment_response => {

          //NAVIGATE TO RECEIPT PAGE
          this.router.navigate(['store-payment-receipt', store_payment_response.order_id]);

        }).catch(error => {

            this.handleError(error);

            this.submitted = false;

         });

    }).catch(error => {
      this.handleError(error);
    });


  }


  public emailIsValid(email: string): boolean {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
  }

  handleSelectCountry(country: string){
    this.store_payment_object.credit_card.country = country;
  }

}

class Card_model {
  cardholder_name: string;
  cardnumber:  string;
  cvv:  string;
  month: string;
  year:  string;
  first_name:  string;
  last_name:  string ;
  city:  string ;
  state:  string;
  zip:  string ;
  country: string;

  constructor() {
    this.cardholder_name = '';
    this.cardnumber = '';
    this.cvv = '';
    this.month = '';
    this.year = '';
    this.first_name = '';
    this.last_name = '';
    this.city = '';
    this.state = '';
    this.zip = '';
    this.country = 'US';
  }
}
